/**
 * Base45 (RFC 9285): bytes as QR alphanumeric characters. A QR code holds
 * Base45 at 5.5 bits per character, so it costs ~3 % over raw bytes, and,
 * unlike byte mode, every scanner (BarcodeDetector included) returns it intact.
 */
export const BASE45 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:';

export function encodeBase45(b: Uint8Array): string {
  let s = '';
  for (let i = 0; i + 1 < b.length; i += 2) {
    let n = b[i] * 256 + b[i + 1];
    const c = n % 45; n = (n - c) / 45;
    const d = n % 45; const e = (n - d) / 45;
    s += BASE45[c] + BASE45[d] + BASE45[e];
  }
  if (b.length % 2) {
    const n = b[b.length - 1];
    s += BASE45[n % 45] + BASE45[Math.floor(n / 45)];
  }
  return s;
}

export function decodeBase45(s: string): Uint8Array {
  const v = (ch: string) => {
    const x = BASE45.indexOf(ch);
    if (x < 0) throw new Error(`not base45: ${JSON.stringify(ch)}`);
    return x;
  };
  if (s.length % 3 === 1) throw new Error('bad base45 length');
  const out = new Uint8Array(Math.floor(s.length / 3) * 2 + (s.length % 3 ? 1 : 0));
  let o = 0;
  for (let i = 0; i < s.length; i += 3) {
    if (i + 2 < s.length) {
      const n = v(s[i]) + v(s[i + 1]) * 45 + v(s[i + 2]) * 2025;
      if (n > 0xffff) throw new Error('bad base45 triple');
      out[o++] = n >> 8;
      out[o++] = n & 0xff;
    } else {
      const n = v(s[i]) + v(s[i + 1]) * 45;
      if (n > 0xff) throw new Error('bad base45 pair');
      out[o++] = n;
    }
  }
  return out;
}
